// InvoiceMainForm.js - Updated with Document ID fields passed to BillFromForm and BillToForm
import React from 'react';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import InvoiceHeader from './InvoiceHeader';
import BillFromForm from './BillFromForm';
import BillToForm from './BillToForm';
import InvoiceItem from './InvoiceItem';
import InvoiceTotals from './InvoiceTotals';
import { useTranslation } from 'react-i18next';

const InvoiceMainForm = ({ invoiceState, subTotal, discountAmount, taxAmount, total, balanceDue }) => {  
  const derivedBalanceDue = total || '0.00';
  const { t } = useTranslation();

  return (
    <Card className="p-4 p-xl-5 my-3 my-xl-4">
      <InvoiceHeader
        invoiceDate={invoiceState.invoiceDate}
        dateOfIssue={invoiceState.dateOfIssue}
        invoiceNumber={invoiceState.invoiceNumber}
        editField={invoiceState.editField}
        logo={invoiceState.logo}
        setLogo={invoiceState.setLogo}
        balanceDue={derivedBalanceDue}
        currency={invoiceState.currency}
      />
      <hr className="my-4" />
      <Row className="mb-5">
        <Col>
          <BillFromForm
            billFrom={invoiceState.billFrom}
            billFromEmail={invoiceState.billFromEmail}
            billFromAddress={invoiceState.billFromAddress}
            billFromDocumentId={invoiceState.billFromDocumentId}
            editField={invoiceState.editField}
          />
        </Col>
        <Col>
          <BillToForm
            billTo={invoiceState.billTo}
            billToEmail={invoiceState.billToEmail}
            billToAddress={invoiceState.billToAddress}
            billToDocumentId={invoiceState.billToDocumentId}
            editField={invoiceState.editField}
          />
        </Col>
      </Row>
      <InvoiceItem
        onItemizedItemEdit={invoiceState.onItemizedItemEdit}
        onRowAdd={invoiceState.handleAddEvent}
        onRowDel={invoiceState.handleRowDel}
        currency={invoiceState.currency}
        items={invoiceState.items}
      />
      <Row className="mt-4 justify-content-end">
        <Col lg={6}>
          <InvoiceTotals
            currency={invoiceState.currency}
            subTotal={subTotal}
            discountRate={invoiceState.discountRate}
            discountAmount={discountAmount}
            taxRate={invoiceState.taxRate}
            taxAmount={taxAmount}
            total={total}
          />
        </Col>
      </Row>
      <hr className="my-4" />
      
      {/* Notes Section - Removed controlId from Form.Group */}
      <div className="mb-3">
        <Form.Label className="fw-bold" htmlFor="notes">{t('notes')}</Form.Label>
        <Form.Control
          placeholder={t('enterAdditionalNotes')}
          name="notes"
          value={invoiceState.notes}
          onChange={invoiceState.editField}
          as="textarea"
          rows={2}
        />
      </div>
      
      {/* Terms Section - Removed controlId from Form.Group */}
      <div className="mb-3">
        <Form.Label className="fw-bold" htmlFor="terms">{t('terms')}</Form.Label>
        <Form.Control
          placeholder={t('enterTermsAndConditions')}
          name="termsAndConditions"
          value={invoiceState.termsAndConditions}
          onChange={invoiceState.editField}
          as="textarea"
          rows={2}
        />
      </div>
    </Card>
  );
};

export default InvoiceMainForm;